import React from "react";

const Redirect: React.FC = () => {

  return (
    <>
      <div className="row intro">
        <div className="large-12 columns box redirect">
          <div className="intro-copy">
            <h1>Sorry, that appeal is now closed.</h1>
            <p className="text-center">Thank you for your interest in supporting the Royal Botanic Gardens, Kew.</p>
            <p className="text-center">We're redirecting you to our latest appeal page.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Redirect;



